import { render, staticRenderFns } from "./AddCourse.vue?vue&type=template&id=77e835f6&scoped=true&"
import script from "./AddCourse.vue?vue&type=script&lang=js&"
export * from "./AddCourse.vue?vue&type=script&lang=js&"
import style0 from "./AddCourse.vue?vue&type=style&index=0&lang=less&"
import style1 from "./AddCourse.vue?vue&type=style&index=1&id=77e835f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e835f6",
  null
  
)

export default component.exports